<ng-container *ngIf="loaded">
  <div class="w-full" style="border-bottom: grey 1px solid">
    <h2 class="p-16 m-0">
      Test Results - {{ model.calibration.isPreCalibration ? "Pre" : "Post" }} Calibration
    </h2>
  </div>
  <div class="px-16 py-32">
    <form #calibrationForm *ngIf="calibrationFormGroup" [formGroup]="calibrationFormGroup">

      <div class="grid grid-cols-4 gap-4">
        <mat-form-field class="col-span-2">
          <mat-label>Booking Ref</mat-label>
          <input
            matInput
            placeholder="Booking ref"
            formControlName="bookingRef"
            required
            value="{{ model.calibration.bookingRef }}"
            readonly="true"
          />
        </mat-form-field>

        <div class="col-span-2">
          <h4>Pressure Test</h4>
          <div class="pressure-test-radio-group">
            <div class="mr-16">
              <input
                id="radioOne"
                type="radio"
                [value]="pressureTestResult.Pass"
                name="pressureRadio"
                [checked]="
                  model.calibration.pressureTestResult ==
                  pressureTestResult.Pass
                "
                (change)="updatePressureRadio($event)"
              />
              <label for="radioOne" class="ml-2">Pass</label>
            </div>
            <div class="mr-16">
              <input
                id="radioTwo"
                type="radio"
                [value]="pressureTestResult.Fail"
                name="pressureRadio"
                [checked]="
                  model.calibration.pressureTestResult ==
                  pressureTestResult.Fail
                "
                (change)="updatePressureRadio($event)"
              />
              <label for="radioTwo" class="ml-2">Fail</label>
            </div>
            <div class="mr-16">
              <input
                id="radioThree"
                type="radio"
                [value]="pressureTestResult.NA"
                name="pressureRadio"
                [checked]="
                  model.calibration.pressureTestResult ==
                  pressureTestResult.NA
                "
                (change)="updatePressureRadio($event)"
              />
              <label for="radioThree" class="ml-2">N/A</label>
            </div>
          </div>
        </div>

        <mat-form-field class="col-span-2">
          <mat-label>TW3.0 Link unit S/N</mat-label>
          <input
            matInput
            placeholder="TW3.0 Link unit S/N"
            formControlName="tW30LinkUnitSN"
            required
            value="{{ model.calibration.linkUnit }}"
            (change)="updateLinkUnit($event)"
          />
        </mat-form-field>
        
        <mat-form-field class="col-span-2">
          <mat-label>Pressure Gauge</mat-label>
          <mat-select
            [value]="getPressureMachine(model.calibration.pressureTestMachine)"
            (selectionChange)="
              model.calibration.pressureTestMachine = $event.value
            "
            [disabled]="
              model.calibration.pressureTestResult == pressureTestResult.NA
            "
          >
            <mat-option
              *ngFor="let pressureMachineOption of pressureMachineList"
              [value]="pressureMachineOption"
            >
              {{ pressureMachineOption.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="col-span-2">
          <mat-label>Link Unit Firmware</mat-label>
          <input
            matInput
            placeholder="Link unit firmware"
            formControlName="linkUnitFirmware"
            value="{{ model.calibration.linkUnitFirmware }}"
            (change)="updateLinkUnitFirmware($event)"
          />
        </mat-form-field>
        
        <mat-form-field class="col-span-2">
          <mat-label>Pressure Rating</mat-label>
          <input
            matInput
            placeholder="Pressure rating"
            formControlName="pressureRating"
            [required]="
              model?.calibration?.pressureTestResult != pressureTestResult.NA
            "
            value="{{ model.calibration.pressureRating }}"
            (change)="updatePressureRating($event)"
            [readonly]="
              model.calibration.pressureTestResult == pressureTestResult.NA
            "
          />
        </mat-form-field>

        <mat-form-field class="col-span-2">
          <mat-label>TW3.0 HDD S/N</mat-label>
          <input
            matInput
            placeholder="TW3.0 HDD S/N"
            formControlName="tW30HDDSN"
            required
            value="{{ model.calibration.handheld }}"
            (change)="updateHandheld($event)"
          />
        </mat-form-field>
        
        <mat-form-field class="col-span-2">
          <mat-label>Multimeter S/N</mat-label>
          <input
            matInput
            placeholder="Multimeter S/N"
            formControlName="multiMeterSN"
            value="{{ model.calibration.multimeter }}"
            (change)="updateMultimeter($event)"
          />
        </mat-form-field>
        
        <mat-form-field class="col-span-2">
          <mat-label>Radio Firmware</mat-label>
          <input
            matInput
            placeholder="Radio firmware"
            formControlName="radioFirmware"
            required
            value="{{ model.calibration.radioFirmware }}"
            (change)="updateRadioFirmware($event)"
          />
        </mat-form-field>
        
        <mat-form-field class="col-span-2">
          <mat-label>Handheld Firmware</mat-label>
          <input
            matInput
            placeholder="Handheld firmware"
            formControlName="handHeldFirmware"
            value="{{ model.calibration.handheldFirmware }}"
            (change)="updateHandheldFirmware($event)"
          />
        </mat-form-field>
        
        <mat-form-field class="col-span-2">
          <mat-label>WLL</mat-label>
          <input
            matInput
            placeholder="WLL"
            formControlName="sWL"
            required
            value="{{ model.calibration.swl }}"
            (change)="updateSWL($event)"
          />
        </mat-form-field>
        
        <mat-form-field class="col-span-2" [class.mat-form-field-invalid]="calibrationFormGroup.dirty && !model.calibration.proofLoad">
          <mat-label>Proof Load</mat-label>
          <input
            matInput
            placeholder="Proof load"
            formControlName="proofLoad"
            required
            type="text"
            [value]="this.calibrationFormGroup?.controls['proofLoad']?.value"
            (change)="updateProofLoad($event)"
            (focus)="calibrationFormGroup.controls['proofLoad'].setValue('')"
          />
        </mat-form-field>
        
        <mat-form-field class="col-span-2">
          <mat-label>MV / V Output at WLL</mat-label>
          <input
            matInput
            placeholder="MV / V Output at WLL"
            formControlName="mVVOutputAtSWL"
            required
            value="{{ model.calibration.output }}"
            (change)="updateOutput($event)"
          />
        </mat-form-field>
        
        <mat-form-field class="col-span-2">
          <mat-label>Range</mat-label>
          <input
            matInput
            placeholder="Range"
            formControlName="range"
            value="{{ model.calibration.range }}"
            (change)="updateRange($event)"
          />
        </mat-form-field>
        
        <mat-form-field class="col-span-2" [class.mat-form-field-invalid]="calibrationFormGroup.dirty && !model.calibration.sensingElement">
          <mat-label>Sensing Element</mat-label>
          <mat-select
            [value]="model.calibration.sensingElement"
            (selectionChange)="model.calibration.sensingElement = $event.value"
            required
          >
            <mat-option
              *ngFor="let sensingElement of sensingElementList"
              [value]="sensingElement.value"
            >
              {{ sensingElement.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        
        <mat-form-field class="col-span-2" [class.mat-form-field-invalid]="calibrationFormGroup.dirty && !model.calibration.resistance">
          <mat-label>Element resistance</mat-label>
          <mat-select
            [value]="model.calibration.resistance"
            (selectionChange)="model.calibration.resistance = $event.value"
            required
          >
            <mat-option
              *ngFor="let resistance of elementResistanceList"
              [value]="resistance"
            >
              {{ resistance }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        
        <div class="col-span-2 flex flex-col">
          <mat-form-field [class.mat-form-field-invalid]="calibrationFormGroup.dirty && !model.calibration.electricalEquipment">
            <mat-label>Electrical Equipment</mat-label>
            <mat-select
              required
              [value]="
                getElectricalEquipment(model.calibration.electricalEquipment)
              "
              (selectionChange)="
                model.calibration.electricalEquipment = $event.value
              "
            >
              <mat-option
                *ngFor="let electricalEquipmentOption of electricalEquipmentList"
                [value]="electricalEquipmentOption"
              >
                {{ electricalEquipmentOption.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-checkbox
            class="-mt-2"
            [checked]="!model.calibration.hideElectricalEquipmentOnCert"
            (change)="model.calibration.hideElectricalEquipmentOnCert = !$event.checked">Include on Certificate</mat-checkbox>
        </div>
        
        <mat-form-field class="col-span-2 h-min">
          <mat-label>Serial Number</mat-label>
          <input
            matInput
            placeholder="Number"
            value="{{ model?.calibration?.electricalEquipment?.serialNumber }}"
            readonly
          />
        </mat-form-field>
        
        <div class="col-span-2">
          <h4>Test Machine</h4>
          <div class="radio-group">
            <div class="mr-16">
              <input
                id="radioNone"
                type="radio"
                [value]="0"
                name="testMachineRadio"
                [checked]="!model.calibration.machineRating"
                (change)="updateTestMachine($event)"
              />
              <label for="radio0" class="ml-2">None</label>
            </div>
            <div class="mr-16">
              <input
                id="radio1T"
                type="radio"
                [value]="machineRating.One"
                name="testMachineRadio"
                [checked]="model.calibration.machineRating == machineRating.One"
                (change)="updateTestMachine($event)"
              />
              <label for="radio1T" class="ml-2">25T</label>
            </div>
            <div class="mr-16">
              <input
                id="radio60T"
                type="radio"
                [value]="machineRating.Sixty"
                name="testMachineRadio"
                [checked]="
                  model.calibration.machineRating == machineRating.Sixty
                "
                (change)="updateTestMachine($event)"
              />
              <label for="radio60T" class="ml-2">60T</label>
            </div>
            <div class="mr-16">
              <input
                id="radio100T"
                type="radio"
                [value]="machineRating.OneHundred"
                name="testMachineRadio"
                [checked]="
                  model.calibration.machineRating == machineRating.OneHundred
                "
                (change)="updateTestMachine($event)"
              />
              <label for="radio100T" class="ml-2">100T</label>
            </div>
            <div class="mr-16">
              <input
                id="radio3000kN"
                type="radio"
                [value]="machineRating.ThreeThousand"
                name="testMachineRadio"
                [checked]="
                  model.calibration.machineRating == machineRating.ThreeThousand
                "
                (change)="updateTestMachine($event)"
              />
              <label for="radio3000kN" class="ml-2">3000 kN</label>
            </div>
            <div class="mr-16">
              <input
                id="radioOther"
                type="radio"
                [value]="machineRating.Other"
                name="testMachineRadio"
                [checked]="
                  model.calibration.machineRating == machineRating.Other
                "
                (change)="updateTestMachine($event)"
              />
              <label for="radioOther" class="ml-2">Other</label>
            </div>
          </div>
        </div>

        <mat-form-field class="col-span-2" [class.mat-form-field-invalid]="calibrationFormGroup.dirty && !model.calibration.testMachineMeasurementResponse?.measurementId">
          <mat-label>Test Machine Unit</mat-label>
          <mat-select
            [value]="
              getMeasurement(
                model?.calibration?.testMachineMeasurementResponse
                  ?.measurementId
              )
            "
            (selectionChange)="updateTestMachineUnit($event)"
            required
          >
            <mat-option
              *ngFor="let measurementOption of measurementList"
              [value]="measurementOption"
            >
              {{ measurementOption?.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div
          *ngFor="let equipment of model.calibration.equipmentList"
          class="col-span-4 grid grid-cols-2 gap-4"
        >
          <mat-form-field>
            <mat-label>Cal Equipment</mat-label>
            <mat-select
              [value]="getMachine(equipment)"
              (selectionChange)="updateMachine(equipment, $event)"
              [disabled]="
                model.calibration.machineRating != machineRating.Other
              "
            >
              <mat-option
                *ngFor="let machineOption of machineList"
                [value]="machineOption"
              >
                {{ machineOption.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          
          <div class="flex flex-row items-center">
            <mat-form-field class="w-full mr-16">
              <mat-label>Serial Number</mat-label>
              <input
                matInput
                placeholder="Number"
                value="{{ equipment.machine?.serialNumber }}"
                readonly
              />
            </mat-form-field>
            <button
              *ngIf="model.calibration.machineRating == machineRating.Other"
              class="delete-line-btn"
              mat-icon-button
              color="warn"
              (click)="deleteEquipmentLine(equipment)"
            >
              <mat-icon>delete_outline</mat-icon>
            </button>
          </div>
        </div>

        <div
          *ngIf="model.calibration.machineRating == machineRating.Other"
          class="flex flex-row items-center px-16 mx-16 mt-16 grid-cols-4"
          (click)="addEquipmentLine()"
        >
          <mat-icon class="add-icon material-icons-outlined mx-16"
            >add</mat-icon
          >
          <p class="add-line m-0">Add Equipment</p>
        </div>



        <div class="col-span-4 grid grid-cols-5 items-center gap-x-4" [class.container-field-invalid]="calibrationFormGroup.dirty && !model.calibration.blocks?.length">
          
          <mat-label class="col-span-5 mb-16">Blocks *</mat-label>
          
          <ng-container *ngFor="let calibrationBlock of model.calibration.blocks; let i = index;">
      
            <mat-form-field class="col-span-2">
              <mat-label>Calibration Block</mat-label>
              <mat-select
                [value]="calibrationBlock.calibrationBlockOptionId"
                (selectionChange)="selectBlockOption(calibrationBlock, $event.value)"
              >
                <mat-option *ngFor="let option of blockOptions" [value]="option.id">
                  {{ option.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          
            <mat-form-field>
              <mat-label>Block Number</mat-label>
              <input
                matInput
                placeholder="Block number"
                [value]="calibrationBlock.blockNumber"
                (change)="calibrationBlock.blockNumber = $event.target.value;"
              />
            </mat-form-field>

            <!-- Colour is unlinked from the block option and picked manually. -->
            <mat-form-field>
              <mat-label>Block Colour</mat-label>
              <mat-select
                [style]="
                  getBackgroundColourString(calibrationBlock.blockColour)
                "
                [value]="calibrationBlock.blockColour"
                (selectionChange)="selectBlockColour(calibrationBlock, $event.value)"
              >
                <mat-option
                  *ngFor="let option of blockColourList"
                  [value]="option.value"
                  [style]="getBackgroundColourString(option.value)"
                >
                  {{ option.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <button
              class="delete-line-btn"
              mat-icon-button
              color="warn"
              (click)="removeBlockLine(i)"
            >
              <mat-icon>delete_outline</mat-icon>
            </button>

          </ng-container>

          <div
            class="flex flex-row items-center mb-16 grid-cols-5 w-max pr-5 cursor-pointer"
            (click)="addBlockLine()"
          >
            <mat-icon class="add-icon material-icons-outlined mx-16"
              >add</mat-icon
            >
            <p class="add-line m-0">Add Block</p>
          </div>

        </div>

        
        <div class="flex flex-row col-span-4 mt-6 mb-3">
          <div class="flex border-b items-center">
            <h2 class="mb-0 pr-16">Table of Results</h2>
            <h4 *ngIf="model.calibration.isNonStandardCalibration" class="non-standard-reminder mb-0">(Non Standard Calibration)</h4>
          </div>
          <mat-tab-group
            mat-stretch-tabs="false"
            mat-align-tabs="start"
            color="primary"
            [selectedIndex]="model.calibration.isCompression == null ? 2 : model.calibration.isCompression ? 1 : 0"
            (selectedIndexChange)="updateIsCompression($event)">
              <mat-tab label="Tension"></mat-tab>
              <mat-tab label="Compression"></mat-tab>
              <mat-tab label="Tension & Compression"></mat-tab>
          </mat-tab-group>
        </div>

        <mat-form-field class="col-span-2" [class.mat-form-field-invalid]="calibrationFormGroup.dirty && !model.calibration.measurementResponse?.measurementId">
          <mat-label>Measured In</mat-label>
          <mat-select
            [value]="
              getMeasurement(
                model?.calibration?.measurementResponse?.measurementId
              )
            "
            (selectionChange)="updateMeasuredIn($event)"
            required
          >
            <mat-option
              *ngFor="let measurementOption of measurementList"
              [value]="measurementOption"
            >
              {{ measurementOption?.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        
        <mat-form-field class="col-span-2">
          <mat-label>Resolution</mat-label>
          <input
            matInput
            type="text"
            placeholder="Resolution"
            formControlName="resolution"
            [value]="resolution"
            (input)="resolution = $event.target.value"
            (keydown.enter)="$event.preventDefault()"
          />
        </mat-form-field>
        
        <div class="col-span-4 grid grid-cols-9 gap-2 items-center">

          <ng-container *ngFor="let result of model.calibration.resultList; let i = index">
            <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'dynamic'" [class.mat-form-field-invalid]="calibrationFormGroup.dirty && !result.machineReadings">
              <input
                matInput
                type="number"
                placeholder="Machine readings"
                required
                value="{{
                  result.machineReadings != null
                    ? getScaledValue(result.machineReadings)
                    : null
                }}"
                (change)="updateMachineReadings(result, $event)"
                (keydown.enter)="$event.preventDefault()"
                [disabled]="disableEdit"
                [tabIndex]="i + 1"
              />
            </mat-form-field>

            <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
              <input
                matInput
                type="number"
                placeholder="Desired"
                [required]="isRequired(model.calibration)"
                value="{{
                  result.desired != null ? getScaledValue(result.desired) : null
                }}"
                (change)="updateDesired(result, $event)"
                (keydown.enter)="$event.preventDefault()"
                [disabled]="disableEdit"
                [tabIndex]="model.calibration.resultList.length + i + 1"
              />
            </mat-form-field>

            <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
              <input
                matInput
                type="number"
                placeholder="Run 1"
                required
                value="{{
                  result.run1 != null ? getScaledValue(result.run1) : null
                }}"
                (change)="updateRun1(result, $event)"
                (keydown.enter)="$event.preventDefault()"
                [disabled]="disableEdit"
                [tabIndex]="model.calibration.resultList.length * 2 + i + 1"
              />
            </mat-form-field>

            <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
              <input
                matInput
                type="number"
                placeholder="Run 2"
                required
                value="{{
                  result.run2 != null ? getScaledValue(result.run2) : null
                }}"
                (change)="updateRun2(result, $event)"
                (keydown.enter)="$event.preventDefault()"
                [disabled]="disableEdit"
                [tabIndex]="model.calibration.resultList.length * 3 + i + 1"
              />
            </mat-form-field>

            <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
              <input
                matInput
                type="number"
                placeholder="Run 3"
                required
                value="{{
                  result.run3 != null ? getScaledValue(result.run3) : null
                }}"
                (change)="updateRun3(result, $event)"
                (keydown.enter)="$event.preventDefault()"
                [disabled]="disableEdit"
                [tabIndex]="model.calibration.resultList.length * 4 + i + 1"
              />
            </mat-form-field>
            
            <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
              <input
                matInput
                type="number"
                placeholder="Run 4"
                required
                value="{{
                  result.run4 != null ? getScaledValue(result.run4) : null
                }}"
                (change)="updateRun4(result, $event)"
                (keydown.enter)="$event.preventDefault()"
                [disabled]="disableEdit"
                [tabIndex]="model.calibration.resultList.length * 5 + i + 1"
              />
            </mat-form-field>

            <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
              <input
                matInput
                type="number"
                placeholder="Run 5"
                required
                value="{{
                  result.run5 != null ? getScaledValue(result.run5) : null
                }}"
                (change)="updateRun5(result, $event)"
                (keydown.enter)="$event.preventDefault()"
                [disabled]="disableEdit"
                [tabIndex]="model.calibration.resultList.length * 6 + i + 1"
              />
            </mat-form-field>

            <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
              <input
                matInput
                type="text"
                placeholder="Error"
                value="{{
                  (result.error ?? 0).toFixed(2) + '%'
                }}"
                readonly
                [disabled]="disableEdit"
              />
            </mat-form-field>

            <button
              class="delete-line-btn"
              mat-icon-button
              color="warn"
              submit="false"
              (click)="deleteResultLine(result)"
              [disabled]="disableEdit"
            >
              <mat-icon>delete_outline</mat-icon>
            </button>
          </ng-container>

          <ng-container *ngIf="model?.calibration?.resultList?.length">
            <label class="col-span-2 segoe">Include on certificate: </label>

            <mat-checkbox
              id="include1"
              class="toggle-run-checkbox"
              labelPosition="before"
              matInput
              [checked]="model.calibration.includeRun1"
              (change)="toggleIncludeRun(1, $event)"
              [disabled]="disableEdit"
            >
            </mat-checkbox>
            <mat-checkbox
              class="toggle-run-checkbox"
              labelPosition="before"
              matInput
              [checked]="model.calibration.includeRun2"
              (change)="toggleIncludeRun(2, $event)"
              [disabled]="disableEdit"
            >
            </mat-checkbox>
            <mat-checkbox
              class="toggle-run-checkbox"
              labelPosition="before"
              matInput
              [checked]="model.calibration.includeRun3"
              (change)="toggleIncludeRun(3, $event)"
              [disabled]="disableEdit"
            >
            </mat-checkbox>
            <mat-checkbox
              class="toggle-run-checkbox"
              labelPosition="before"
              matInput
              [checked]="model.calibration.includeRun4"
              (change)="toggleIncludeRun(4, $event)"
              [disabled]="disableEdit"
            >
            </mat-checkbox>
            <mat-checkbox
              class="toggle-run-checkbox"
              labelPosition="before"
              matInput
              [checked]="model.calibration.includeRun5"
              (change)="toggleIncludeRun(5, $event)"
              [disabled]="disableEdit"
            >
            </mat-checkbox>

            <div class="col-span-2"></div>
          </ng-container>

          <div class="col-span-9">
            <div *ngIf="!disableEdit" class="flex flex-row w-max pr-5 cursor-pointer" (click)="addResultsLine()">
              <mat-icon class="add-icon material-icons-outlined mx-16"
                >add</mat-icon
              >
              <p class="add-line m-0">Add Result</p>
            </div>
          </div>

          <!-- Archived Results -->
          <ng-container *ngIf="archivedRuns?.length">
            <mat-slide-toggle class="col-span-9 mt-3" color="primary" [checked]="showArchivedRuns" (change)="showArchivedRuns = $event.checked">
              <span class="pl-4">Show Archived Calibration Rows</span>
            </mat-slide-toggle>

            <ng-container *ngIf="showArchivedRuns">
              <ng-container *ngFor="let result of archivedRuns">
                <div class="pl-2">{{ result.machineReadings != null ? getScaledValue(result.machineReadings) : 0 }}</div>
                <div>{{ result.desired != null ? getScaledValue(result.desired) : 0 }}</div>
                <div>{{ result.run1 != null ? getScaledValue(result.run1) : 0 }}</div>
                <div>{{ result.run2 != null ? getScaledValue(result.run2) : 0 }}</div>
                <div>{{ result.run3 != null ? getScaledValue(result.run3) : 0 }}</div>
                <div>{{ result.run4 != null ? getScaledValue(result.run4) : 0 }}</div>
                <div>{{ result.run5 != null ? getScaledValue(result.run5) : 0 }}</div>
                <div>{{ (result.error ?? 0).toFixed(2) + '%' }}</div>
                <button
                  class="delete-line-btn"
                  mat-icon-button
                  submit="false"
                  (click)="reinstateResultLine(result)"
                >
                  <mat-icon [svgIcon]="'heroicons_outline:arrow-uturn-left'"></mat-icon>
                </button>
              </ng-container>
            </ng-container>
          </ng-container>


          <!-- Additional Results Set Toggle-->
          <div
            *ngIf="!model.calibration.additionalResultsSet"
            class="flex flex-row items-center col-span-9 w-max pr-5 cursor-pointer mt-14"
            (click)="model.calibration.additionalResultsSet = true"
          >
            <mat-icon class="add-icon material-icons-outlined mr-16">add</mat-icon>
            <p class="add-line m-0">Add second table of results</p>
          </div>
        </div>

        <ng-container *ngIf="model.calibration.additionalResultsSet">

          <div class="flex flex-row col-span-4 mt-6 mb-3">
            <div class="flex border-b items-center">
              <h2 class="mb-0 pr-16">Table of Results 2</h2>
              <h4 *ngIf="model.calibration.isNonStandardCalibration" class="non-standard-reminder mb-0">(Non Standard Calibration)</h4>
            </div>
            <mat-tab-group
              mat-stretch-tabs="false"
              mat-align-tabs="start"
              color="primary"
              [selectedIndex]="model.calibration.additionalIsCompression == null ? 2 : model.calibration.additionalIsCompression ? 1 : 0"
              (selectedIndexChange)="updateAdditionalIsCompression($event)">
                <mat-tab label="Tension"></mat-tab>
                <mat-tab label="Compression"></mat-tab>
                <mat-tab label="Tension & Compression"></mat-tab>
            </mat-tab-group>
            <div
              class="flex flex-row items-center col-span-9 w-max pr-5 cursor-pointer ml-auto"
              (click)="model.calibration.additionalResultsSet = false"
            >
              <mat-icon class="add-icon material-icons-outlined mr-16">remove</mat-icon>
              <p class="add-line m-0">Remove second table of results</p>
            </div>
          </div>

          <!-- Additional results fields -->
          <div class="col-span-2 flex flex-col">
            <mat-form-field [class.mat-form-field-invalid]="calibrationFormGroup.dirty && !model.calibration.additionalElectricalEquipment">
              <mat-label>Electrical Equipment</mat-label>
              <mat-select
                required
                [value]="
                  getElectricalEquipment(
                    model.calibration.additionalElectricalEquipment
                  )
                "
                (selectionChange)="
                  model.calibration.additionalElectricalEquipment = $event.value
                "
              >
                <mat-option
                  *ngFor="
                    let electricalEquipmentOption of electricalEquipmentList
                  "
                  [value]="electricalEquipmentOption"
                >
                  {{ electricalEquipmentOption.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-checkbox
              class="-mt-2"
              [checked]="!model.calibration.hideAdditionalElectricalEquipmentOnCert"
              (change)="model.calibration.hideAdditionalElectricalEquipmentOnCert = !$event.checked">Include on Certificate</mat-checkbox>
          </div>
          
          <mat-form-field class="col-span-2 h-min">
            <mat-label>Serial Number</mat-label>
            <input
              matInput
              placeholder="Number"
              value="{{
                model?.calibration?.additionalElectricalEquipment?.serialNumber
              }}"
              readonly
            />
          </mat-form-field>

          <div class="col-span-2">
            <h4>Test Machine</h4>
            <div class="radio-group">
              <div class="mr-16">
                <div class="mr-16">
                  <input
                    id="additionalRadioNone"
                    type="radio"
                    [value]="0"
                    name="additionalTestMachineRadio"
                    [checked]="!model.calibration.additionalMachineRating"
                    (change)="updateTestMachine($event, true)"
                  />
                  <label for="radio0" class="ml-2">None</label>
                </div>
                <input
                  id="additionalRadio1T"
                  type="radio"
                  [value]="machineRating.One"
                  name="additionalTestMachineRadio"
                  [checked]="
                    model.calibration.additionalMachineRating ==
                    machineRating.One
                  "
                  (change)="updateTestMachine($event, true)"
                />
                <label for="additionalRadio1T" class="ml-2">25T</label>
              </div>
              <div class="mr-16">
                <input
                  id="additionalRadio60T"
                  type="radio"
                  [value]="machineRating.Sixty"
                  name="additionalTestMachineRadio"
                  [checked]="
                    model.calibration.additionalMachineRating ==
                    machineRating.Sixty
                  "
                  (change)="updateTestMachine($event, true)"
                />
                <label for="additionalRadio60T" class="ml-2">60T</label>
              </div>
              <div class="mr-16">
                <input
                  id="additionalRadio100T"
                  type="radio"
                  [value]="machineRating.OneHundred"
                  name="additionalTestMachineRadio"
                  [checked]="
                    model.calibration.additionalMachineRating ==
                    machineRating.OneHundred
                  "
                  (change)="updateTestMachine($event, true)"
                />
                <label for="additionalRadio100T" class="ml-2">100T</label>
              </div>
              <div class="mr-16">
                <input
                  id="additionalRadio3000kN"
                  type="radio"
                  [value]="machineRating.ThreeThousand"
                  name="additionalTestMachineRadio"
                  [checked]="
                    model.calibration.additionalMachineRating ==
                    machineRating.ThreeThousand
                  "
                  (change)="updateTestMachine($event, true)"
                />
                <label for="additionalRadio3000kN" class="ml-2">3000 kN</label>
              </div>
              <div class="mr-16">
                <input
                  id="additionalRadioOther"
                  type="radio"
                  [value]="machineRating.Other"
                  name="additionalTestMachineRadio"
                  [checked]="
                    model.calibration.additionalMachineRating ==
                    machineRating.Other
                  "
                  (change)="updateTestMachine($event, true)"
                />
                <label for="additionalRadioOther" class="ml-2">Other</label>
              </div>
            </div>
          </div>

          <mat-form-field class="col-span-2" [class.mat-form-field-invalid]="calibrationFormGroup.dirty && !model.calibration.additionalTestMachineMeasurementResponse?.measurementId">
            <mat-label>Test Machine Unit</mat-label>
            <mat-select
              [value]="
                getMeasurement(
                  model?.calibration?.additionalTestMachineMeasurementResponse
                    ?.measurementId
                )
              "
              (selectionChange)="updateTestMachineUnit($event, true)"
              required
            >
              <mat-option
                *ngFor="let measurementOption of measurementList"
                [value]="measurementOption"
              >
                {{ measurementOption?.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <ng-container *ngFor="let equipment of model.calibration.additionalEquipmentList">
            <mat-form-field class="col-span-2">
              <mat-label>Cal Equipment</mat-label>
              <mat-select
                [value]="getMachine(equipment)"
                (selectionChange)="updateMachine(equipment, $event, true)"
                [disabled]="
                  model.calibration.additionalMachineRating !=
                  machineRating.Other
                "
              >
                <mat-option
                  *ngFor="let machineOption of machineList"
                  [value]="machineOption"
                >
                  {{ machineOption.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            
            <div class="flex flex-row items-center col-span-2">
              <mat-form-field class="w-full mr-16">
                <mat-label>Serial Number</mat-label>
                <input
                  matInput
                  placeholder="Number"
                  value="{{ equipment.machine?.serialNumber }}"
                  readonly
                />
              </mat-form-field>
              <button
                *ngIf="
                  model.calibration.additionalMachineRating ==
                  machineRating.Other
                "
                class="delete-line-btn"
                mat-icon-button
                color="warn"
                (click)="deleteEquipmentLine(equipment)"
              >
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>
          </ng-container>

          <div
            *ngIf="model.calibration.additionalMachineRating == machineRating.Other"
            class="flex flex-row items-center col-span-4 w-max pr-5 cursor-pointer"
            (click)="addEquipmentLine(true)"
          >
            <mat-icon class="add-icon material-icons-outlined mx-16"
              >add</mat-icon
            >
            <p class="add-line m-0">Add Equipment</p>
          </div>
            
          <mat-form-field class="col-span-2" [class.mat-form-field-invalid]="calibrationFormGroup.dirty && !model.calibration.additionalMeasurementResponse?.measurementId">
            <mat-label>Measured In</mat-label>
            <mat-select
              [value]="
                getMeasurement(
                  model?.calibration?.additionalMeasurementResponse
                    ?.measurementId
                )
              "
              (selectionChange)="updateMeasuredIn($event, true)"
              required
            >
              <mat-option
                *ngFor="let measurementOption of measurementList"
                [value]="measurementOption"
              >
                {{ measurementOption?.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          
          <mat-form-field class="col-span-2">
            <mat-label>Resolution</mat-label>
            <input
              matInput
              type="text"
              placeholder="Resolution"
              formControlName="additionalResolution"
              [value]="additionalResolution"
              (input)="additionalResolution = $event.target.value"
              (keydown.enter)="$event.preventDefault()"
            />
          </mat-form-field>

          <div class="flex flex-row col-span-4">
            <h4 class="mb-0 mr-16">Table of Results</h4>
            <h4 class="non-standard-reminder mb-0">
              {{
                model.calibration.isNonStandardCalibration
                  ? "(Non Standard Calibration)"
                  : ""
              }}
            </h4>
          </div>

          <div class="col-span-4 grid grid-cols-9 gap-2 items-center">
            <ng-container *ngFor="let result of model.calibration.additionalResultList; let i = index">

              <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'dynamic'" [class.mat-form-field-invalid]="calibrationFormGroup.dirty && !result.machineReadings">
                <input
                  matInput
                  type="number"
                  placeholder="Machine readings"
                  required
                  value="{{
                    result.machineReadings != null
                      ? getScaledValue(result.machineReadings, true)
                      : null
                  }}"
                  (change)="updateMachineReadings(result, $event, true)"
                  (keydown.enter)="$event.preventDefault()"
                  [disabled]="disableEdit"
                  [tabIndex]="i + 1 + model.calibration.resultList.length * 7"
                />
              </mat-form-field>
              <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
                <input
                  matInput
                  type="number"
                  placeholder="Desired"
                  [required]="isRequired(model.calibration)"
                  value="{{
                    result.desired != null
                      ? getScaledValue(result.desired, true)
                      : null
                  }}"
                  (change)="updateDesired(result, $event, true)"
                  (keydown.enter)="$event.preventDefault()"
                  [disabled]="disableEdit"
                  [tabIndex]="model.calibration.additionalResultList.length + i + 1 + model.calibration.resultList.length * 7"
                />
              </mat-form-field>
              <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
                <input
                  matInput
                  type="number"
                  placeholder="Run 1"
                  required
                  value="{{
                    result.run1 != null ? getScaledValue(result.run1, true) : null
                  }}"
                  (change)="updateRun1(result, $event, true)"
                  (keydown.enter)="$event.preventDefault()"
                  [disabled]="disableEdit"
                  [tabIndex]="model.calibration.additionalResultList.length * 2 + i + 1 + model.calibration.resultList.length * 7"
                />
              </mat-form-field>
              <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
                <input
                  matInput
                  type="number"
                  placeholder="Run 2"
                  required
                  value="{{
                    result.run2 != null ? getScaledValue(result.run2, true) : null
                  }}"
                  (change)="updateRun2(result, $event, true)"
                  (keydown.enter)="$event.preventDefault()"
                  [disabled]="disableEdit"
                  [tabIndex]="model.calibration.additionalResultList.length * 3 + i + 1 + model.calibration.resultList.length * 7"
                />
              </mat-form-field>
              <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
                <input
                  matInput
                  type="number"
                  placeholder="Run 3"
                  required
                  value="{{
                    result.run3 != null ? getScaledValue(result.run3, true) : null
                  }}"
                  (change)="updateRun3(result, $event, true)"
                  (keydown.enter)="$event.preventDefault()"
                  [disabled]="disableEdit"
                  [tabIndex]="model.calibration.additionalResultList.length * 4 + i + 1 + model.calibration.resultList.length * 7"
                />
              </mat-form-field>
              <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
                <input
                  matInput
                  type="number"
                  placeholder="Run 4"
                  required
                  value="{{
                    result.run4 != null ? getScaledValue(result.run4, true) : null
                  }}"
                  (change)="updateRun4(result, $event, true)"
                  (keydown.enter)="$event.preventDefault()"
                  [disabled]="disableEdit"
                  [tabIndex]="model.calibration.additionalResultList.length * 5 + i + 1 + model.calibration.resultList.length * 7"
                />
              </mat-form-field>
              <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
                <input
                  matInput
                  type="number"
                  placeholder="Run 5"
                  required
                  value="{{
                    result.run5 != null ? getScaledValue(result.run5, true) : null
                  }}"
                  (change)="updateRun5(result, $event, true)"
                  (keydown.enter)="$event.preventDefault()"
                  [disabled]="disableEdit"
                  [tabIndex]="model.calibration.additionalResultList.length * 6 + i + 1 + model.calibration.resultList.length * 7"
                />
              </mat-form-field>

              <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
                <input
                  matInput
                  type="text"
                  placeholder="Error"
                  value="{{
                    (result.error ?? 0).toFixed(2) + '%'
                  }}"
                  readonly
                  [disabled]="disableEdit"
                />
              </mat-form-field>
              <button
                class="delete-line-btn"
                mat-icon-button
                color="warn"
                submit="false"
                (click)="deleteResultLine(result)"
                [disabled]="disableEdit"
              >
                <mat-icon>delete_outline</mat-icon>
              </button>

            </ng-container>

            <ng-container *ngIf="model?.calibration?.additionalResultList?.length">
              <label class="segoe col-span-2">Include on certificate: </label>

              <mat-checkbox
                id="additionalInclude1"
                class="toggle-run-checkbox"
                labelPosition="before"
                matInput
                [checked]="model.calibration.additionalIncludeRun1"
                (change)="toggleIncludeRun(1, $event, true)"
                [disabled]="disableEdit"
              >
              </mat-checkbox>
              <mat-checkbox
                class="toggle-run-checkbox"
                labelPosition="before"
                matInput
                [checked]="model.calibration.additionalIncludeRun2"
                (change)="toggleIncludeRun(2, $event, true)"
                [disabled]="disableEdit"
              >
              </mat-checkbox>
              <mat-checkbox
                class="toggle-run-checkbox"
                labelPosition="before"
                matInput
                [checked]="model.calibration.additionalIncludeRun3"
                (change)="toggleIncludeRun(3, $event, true)"
                [disabled]="disableEdit"
              >
              </mat-checkbox>
              <mat-checkbox
                class="toggle-run-checkbox"
                labelPosition="before"
                matInput
                [checked]="model.calibration.additionalIncludeRun4"
                (change)="toggleIncludeRun(4, $event, true)"
                [disabled]="disableEdit"
              >
              </mat-checkbox>
              <mat-checkbox
                class="toggle-run-checkbox"
                labelPosition="before"
                matInput
                [checked]="model.calibration.additionalIncludeRun5"
                (change)="toggleIncludeRun(5, $event, true)"
                [disabled]="disableEdit"
              >
              </mat-checkbox>

              <div class="col-span-2"></div>
            </ng-container>


            <div
              class="flex flex-row col-span-9 w-max pr-5 cursor-pointer"
              (click)="addResultsLine(true)"
              *ngIf="!disableEdit"
            >
              <mat-icon class="add-icon material-icons-outlined mx-16"
                >add</mat-icon
              >
              <p class="add-line m-0">Add Result</p>
            </div>


            <!-- Archived Results -->
            <ng-container *ngIf="archivedAddRuns?.length">
              <mat-slide-toggle class="col-span-9 mt-3" color="primary" [checked]="showArchivedAddRuns" (change)="showArchivedAddRuns = $event.checked">
                <span class="pl-4">Show Archived Calibration Rows</span>
              </mat-slide-toggle>

              <ng-container *ngIf="showArchivedAddRuns">
                <ng-container *ngFor="let result of archivedAddRuns">
                  <div class="pl-2">{{ result.machineReadings != null ? getScaledValue(result.machineReadings) : 0 }}</div>
                  <div>{{ result.desired != null ? getScaledValue(result.desired) : 0 }}</div>
                  <div>{{ result.run1 != null ? getScaledValue(result.run1) : 0 }}</div>
                  <div>{{ result.run2 != null ? getScaledValue(result.run2) : 0 }}</div>
                  <div>{{ result.run3 != null ? getScaledValue(result.run3) : 0 }}</div>
                  <div>{{ result.run4 != null ? getScaledValue(result.run4) : 0 }}</div>
                  <div>{{ result.run5 != null ? getScaledValue(result.run5) : 0 }}</div>
                  <div>{{ (result.error ?? 0).toFixed(2) + '%' }}</div>
                  <button
                    class="delete-line-btn"
                    mat-icon-button
                    submit="false"
                    (click)="reinstateResultLine(result)"
                  >
                    <mat-icon [svgIcon]="'heroicons_outline:arrow-uturn-left'"></mat-icon>
                  </button>
                </ng-container>
              </ng-container>
            </ng-container>

          </div>
        </ng-container>


        <div class="col-span-4 mt-6">
          <h4>Adjustment required?</h4>
          <div class="radio-group">
            <div class="mr-16">
              <input
                id="radioAdjustYes"
                type="radio"
                [value]="0"
                name="adjustmentRequiredRadio"
                [checked]="model.calibration.adjustment == adjustment.Yes"
                (change)="updateAdjustmentRequiredRadio($event)"
              />
              <label for="radioAdjustYes" class="ml-2">Yes</label>
            </div>
            <div class="mr-16">
              <input
                id="radioAdjustNo"
                type="radio"
                [value]="1"
                name="adjustmentRequiredRadio"
                [checked]="model.calibration.adjustment == adjustment.No"
                (change)="updateAdjustmentRequiredRadio($event)"
              />
              <label for="radioAdjustNo" class="ml-2">No</label>
            </div>
            <div class="mr-16">
              <input
                id="radioAdjustUnable"
                type="radio"
                [value]="2"
                name="adjustmentRequiredRadio"
                [checked]="
                  model.calibration.adjustment == adjustment.UnableToAdjust
                "
                (change)="updateAdjustmentRequiredRadio($event)"
              />
              <label for="radioAdjustUnable" class="ml-2">Unable to adjust</label>
            </div>
          </div>
        </div>

        <div class="col-span-4">
          <h4>Does it meet manufacturers spec?</h4>
          <div class="radio-group">
            <div class="mr-16">
              <input
                id="radioManuYes"
                type="radio"
                [value]="ManufacturerSpec.Yes"
                name="manuSpecRadio"
                [checked]="model.calibration.manuSpec == ManufacturerSpec.Yes"
                (change)="updateManuSpecRadio($event)"
              />
              <label for="radioManuYes" class="ml-2">Yes</label>
            </div>
            <div class="mr-16">
              <input
                id="radioManuNo"
                type="radio"
                [value]="ManufacturerSpec.No"
                name="manuSpecRadio"
                [checked]="model.calibration.manuSpec == ManufacturerSpec.No"
                (change)="updateManuSpecRadio($event)"
              />
              <label for="radioManuNo" class="ml-2">No</label>
            </div>
            <div class="mr-16">
              <input
                id="radioManuNo"
                type="radio"
                [value]="ManufacturerSpec.Unknown"
                name="manuSpecRadio"
                [checked]="
                  model.calibration.manuSpec == ManufacturerSpec.Unknown
                "
                (change)="updateManuSpecRadio($event)"
              />
              <label for="radioManuNo" class="ml-2">Unknown</label>
            </div>
          </div>
        </div>

        <div class="col-span-2">
          <small>Signature</small>
          <img src="{{ model?.calibration?.signature }}"/>
        </div>
        <div class="col-span-2"></div>

        <p class="col-span-2">{{ model?.calibration?.employeeName }}</p>

        <mat-form-field class="col-span-2">
          <input
            type="date"
            matInput
            placeholder="Date:"
            formControlName="date"
            required
            [value]="getDate()"
            (change)="updateDate($event)"
          />
        </mat-form-field>

      </div>
    </form>
  </div>

  <div
    class="flex nav-button-spacing-4 justify-end items-end w-full"
    fxLayout="row"
  >
    <button
      *ngIf="!disableEdit"
      mat-flat-button
      matStepperNext
      class="draft-button m-32"
      (click)="close(null)"
    >
      Save As Draft
    </button>
    <span fxFlex="8px"></span>
    <button
      mat-flat-button
      matStepperNext
      class="save-button m-32"
      (click)="saveHandler()"
    >
      Complete
    </button>
  </div>
</ng-container>
